// removed by extract-text-webpack-plugin
module.exports = {"weeks":"_2e0bFvm4VMHD5nQr20FSdn"};


//////////////////
// WEBPACK FOOTER
// ./src/views/wizard/rx-list/gtable/style.css
// module id = 839
// module chunks = 0